import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { api_url_v1 } from "../utils/config";

let token = null;

try {
  token = window.localStorage.getItem('adminToken');
} catch {
  token = null;
}



export const fetchOrders = createAsyncThunk(
    "order/fetchOrders",
    async (customerId, { rejectWithValue }) => {
      try {
        const response = await axios.post(
          `${api_url_v1}/getAllOrders`,
          { customerId }, 
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            
              params: {
                _cb: Date.now(), // cache buster
              },
            
          }
        );
  
        return response.data.data || response.data;
      } catch (error) {
        if (error.response?.data) {
          return rejectWithValue(
            error.response.data.message || "Failed to fetch orders"
          );
        }
        return rejectWithValue(error.message || "Network error");
      }
    }
  );

// ✅ Fetch a single order by ID (POST request with ID in body)
export const fetchSingleOrder = createAsyncThunk(
  "order/fetchSingleOrder",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${api_url_v1}/getOrderDetails`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.data || response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message || "Failed to fetch order");
      }
      return rejectWithValue(error.message || "Network error");
    }
  }
);


export const updateOrderStatus = createAsyncThunk(
  'orders/updateOrderStatus',
  async ({ payId, status }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${api_url_v1}/setOrderStatus`, {
        pay_id:payId,
        status
      });
      return response.data.data || response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState: {
    orders: [],
    singleOrder: null,
    orderCreated: null,
    loading: false,
    error: null,
    success: false,
    updateLoading: false,
    updateError: null,
    updateSuccess: false
  },
  reducers: {
    clearSingleOrder: (state) => {
      state.singleOrder = null;
    },
    clearOrderCreated: (state) => {
      state.orderCreated = null;
      state.success = false;
    },
    clearOrderError: (state) => {
      state.error = null;
    },
    clearUpdateStatus: (state) => {
      state.updateLoading = false;
      state.updateError = null;
      state.updateSuccess = false;
    }
  },
  extraReducers: (builder) => {
    builder
      

      // Fetch all user orders
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch single order
      .addCase(fetchSingleOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSingleOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.singleOrder = action.payload;
      })
      .addCase(fetchSingleOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       //update status
       .addCase(updateOrderStatus.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
        state.updateSuccess = false;
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
        // Update the order in the state
        const index = state.orders.findIndex(
          order => order.payId === action.payload.payId
        );
        if (index !== -1) {
          state.orders[index].status = action.payload.status;
        }
      })
      .addCase(updateOrderStatus.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
        state.updateSuccess = false;
      });

  
  },
});

export const { clearSingleOrder, clearOrderCreated, clearOrderError,clearUpdateStatus } = orderSlice.actions;
export default orderSlice.reducer;